<div class="position-wrapper">
  <app-match-live-ticker-activity *ngFor="let activity of matchDetailViewService.getActivitiesWithVideos()"
                                  [activity]="activity" [onVideosPage]="true"></app-match-live-ticker-activity>
</div>
<div class="nothing-here-yet" *ngIf="!hasVideos()">
  <p>Für dieses Spiel sind noch keine Videos verfügbar.</p>
</div>
